import classNames from 'classnames';
import React from 'react';
import { Image } from '@udemy/react-core-components';
import styles from "./partner-logos.module.css";

/** React prop interface for a Partner Logo, an array of which serves as props for `PartnerLogos  */

/** React prop interface for `PartnerLogos` component */

/**
 * ### PartnerLogos
 *
 * A rendering of a list of company logos.
 *
 */
export function PartnerLogos({
  logos,
  className = styles.list
}) {
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames('ud-unstyled-list', className)
  }, logos.map((logo, i) => {
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: styles.item
    }, /*#__PURE__*/React.createElement(Image, {
      src: logo.img,
      alt: logo.name,
      width: logo.width,
      height: logo.height
    }));
  }));
}
//# sourceMappingURL=partner-logos.react-component.js.map